import {addEditDialog} from "@/pages/category/_dialog";
import {DialogType} from "@/config";

import {_, DataOptionItem, type PageContext} from '@zto/zpage'



export const LONG_API_TIMEOUT = 60 * 1000
export default {
  body: {
    type: 'crud',

    actions: {
      editBind:{
        api: 'pc/catInfo/create',
        dialog:addEditDialog(DialogType.EDIT)
      },
      hideBind:{
        api: 'pc/catInfo/hide',
      },
      offShelf:{
        api: 'pc/catInfo/offShelf',
      },
      grounding:{
        api: 'pc/catInfo/grounding',
      },
      add:{
        api: 'pc/catInfo/create',
        dialog:addEditDialog(DialogType.ADD)
      },
      query: {
        api: {
          url: 'pc/catInfo/list',
          // mockData: { data: [{ status: ChatGroupBindStatus.UNBIND }] }
          requestTransform: (req: any) => {
            const payload = { ...req }
            return payload
          },

          responseTransform: (resp: any) => {
            (resp.data || []).forEach((it:any) => {
              it.hasChildren = false
              it.shopGoodsCount = 0
              if (it.spuInfoVOList){
                it.shopGoodsCount = it.spuInfoVOList.length
                it.hasChildren = true
              }
            })
            return resp.data
          }
        }
      },
    },


    search: {
      beforeSearch: ({ app, searchParams }: any) => {
        app.setPageData('searchParams', searchParams)
      },
      labelWidth: 100,
      items: [
        { type: 'input', prop: 'catName', label: '分类名称', span: 6, placeholder: '' },
        { label: '分类状态', type: 'select', prop: 'catStatus', options: 'categoryStatus' }
      ]
    },

    toolbar: {
      items: [{ action: 'add', label: '新增分类' }]
    },

    table: ({app}: PageContext) => ({
      innerAttrs: {
        operationPosition: 'right',
        pageSize: 100,
        noIndex: true,
        pageSizes: [5, 10, 15, 20],
        rowKey: 'id',
        loadMethod: async (row: any, node: any, resolve: Function) => {
          resolve(row.spuInfoVOList)
        },
      },

      operation: {
        width: 120,
        items: [
          { action: 'editBind', label: '编辑',  },
          { action: 'hideBind', label: '隐藏',  },
          { action: 'offShelf', label: '下架',  },
          { action: 'grounding', label: '上架',  }
        ]
      },

      columns: [
        { label: '分类名称', prop: 'catName', width: 160, align: 'left', header: { class: 'fw text-center' } },
        { label: '分类id', prop: 'id', width: 100 },
        { label: '商品数量', prop: 'shopGoodsCount', width: 100 },
        { label: '创建时间', prop: 'gmtCreate', width: 150 },
        { label: '分类状态', prop: 'catStatus', width: 100,
          formatter: (data: any) => {
            if(data.catStatus === 'grounding'){
              return '上架'
            }
            else if (data.catStatus === 'off_shelf'){
              return '下架'
            }
            return '-'
          }},
        { label: '商品名称', prop: 'spuName', width: 100 },
        { label: '商品ID', prop: 'id', width: 100 },
        { label: '商品销量', prop: 'price', width: 100 },
        { label: '上架时间', prop: 'gmtCreate', width: 100 },
      ]
    })
  }
}
